var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.669 5.633c0-.735.596-1.33 1.331-1.33.735-.001 1.331.595 1.331 1.33v8.437c0 .735-.595 1.331-1.33 1.331-.736 0-1.332-.595-1.332-1.33V5.632zM12 19.698c-.69 0-1.249-.56-1.249-1.25 0-.689.56-1.248 1.25-1.248.689 0 1.248.56 1.248 1.249 0 .69-.56 1.249-1.249 1.249zM12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12S0 5.372 0 12c.007 6.624 5.376 11.992 12 12z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.1673a332.svg";
export { ForwardRef as ReactComponent };